import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { useState } from 'react';
import { useFieldModifyApi } from '~/components/ui/document/dialogs/documentOverviewDialog/useFieldModifyApi';
import { useDocumentOverviewApi } from './useDocumentOverviewApi';

export function FieldEditDetails(props: {
  documentId: string;
  fieldId: string;
  fieldName: string;
  fieldValue: string | null;
  // deleteField: (fieldId: string) => void;
  type: 'clauses' | 'fields';
}) {
  const { editExtractedField } = useFieldModifyApi();
  const [editExtractedFieldDialogVisible, setEditExtractedFieldDialogVisible] =
    useState(false);
  const [editedValue, setEditedValue] = useState('');
  const { fetchDocumentFields } = useDocumentOverviewApi({
    documentId: props.documentId,
  });

  const fieldActions = (
    <>
      {/* <Button
        icon="pi pi-trash"
        onClick={
          (e) => confirm()
          // props.deleteField(props.fieldId)
        }
        size="small"
        rounded
        text
      ></Button> */}
      {props.type === 'fields' && (
        <Button
          icon="pi pi-pen-to-square"
          onClick={() => setEditExtractedFieldDialogVisible(true)}
          size="small"
          rounded
          text
        />
      )}
    </>
  );

  const handleEditExtractedField = () => {
    editExtractedField(
      props.fieldId,
      props.documentId,
      editedValue,
      afterEditExtractedFieldSuccess,
    );
  };

  const afterEditExtractedFieldSuccess = () => {
    setEditExtractedFieldDialogVisible(false);
    fetchDocumentFields();
  };

  const footerContent = (
    <div>
      <Button
        label="Cancel"
        icon="pi pi-times"
        onClick={() => setEditExtractedFieldDialogVisible(false)}
        className="p-button-text"
      />
      <Button
        label="Update"
        icon="pi pi-check"
        onClick={() => handleEditExtractedField()}
        autoFocus
      />
    </div>
  );

  return (
    <div className="editdetails">
      {/* <Toast ref={toast} /> */}
      {/* {updating || error ? fieldStatus : null}
      {!updating ? fieldActions : null} */}
      {fieldActions}
      <Dialog
        header="Edit Field Value"
        visible={editExtractedFieldDialogVisible}
        footer={footerContent}
        onHide={() => {
          if (!editExtractedFieldDialogVisible) return;
          setEditExtractedFieldDialogVisible(false);
        }}
      >
        <div className="flex flex-column gap-2 w-20rem">
          <span>
            Edit value for <span className="font-bold">{props.fieldName}</span>
          </span>
          <InputText
            id="editedValue"
            placeholder={props.fieldValue || ''}
            value={editedValue}
            onChange={(e) => {
              setEditedValue(e.target.value);
            }}
          />
        </div>
      </Dialog>
    </div>
  );
}
